import { RedirectToSignIn } from '@clerk/clerk-react';
import { Route, Routes } from 'react-router-dom';

import { LandingPage } from './pages/Landing';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { SAMLLoginPage } from './pages/SAMLLogin';
import { SectionLoginPage } from './pages/SectionLogin';
import { SectionTokenPage } from './pages/SectionToken';
import { SAMLCallbackPage } from './pages/SAMLCallback';

export function UnAuthRouter() {
  return (
    <Routes>
      <Route path="/demo" element={<RedirectToSignIn />} />
      <Route path="/demo/*" element={<RedirectToSignIn />} />
      <Route path="/login" element={<RedirectToSignIn />} />
      <Route path="/sign-up" element={<SignupPage />} />
      <Route path="/section" element={<SectionLoginPage />} />
      <Route path="/section/login" element={<SectionTokenPage />} />
      <Route path="/invite" element={<LoginPage />} />
      <Route path="/corp-login" element={<SAMLLoginPage />} />
      <Route path="/corp-callback" element={<SAMLCallbackPage />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}
